"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var profile_container_1 = __importDefault(require("../views/profile-container"));
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var title_container_1 = __importDefault(require("../views/title-container"));
var game_area_1 = require("../utilities/game-area");
var stack_container_1 = __importStar(require("../views/stack-container"));
var color_1 = require("../utilities/color");
var i18next_1 = __importDefault(require("i18next"));
var scoring_row_1 = __importDefault(require("../views/scoring-row"));
var scoring_1 = require("../models/scoring");
var ScoringState = /** @class */ (function (_super) {
    __extends(ScoringState, _super);
    function ScoringState(app, client) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        return _this;
    }
    Object.defineProperty(ScoringState.prototype, "profileContainer", {
        get: function () {
            if (!this._profileContainer) {
                this._profileContainer = new profile_container_1.default(this._app.loader.resources);
                this._profileContainer.scale.set(0.5);
                this._profileContainer.position.set(game_area_1.GAME_WIDTH * 0.5, game_area_1.GAME_HEIGHT * 0.5);
            }
            return this._profileContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScoringState.prototype, "backButton", {
        get: function () {
            var _this = this;
            if (!this._backButton) {
                this._backButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.BACK, function () {
                    _this.stateMachine.pop();
                });
                this._backButton.position.set(game_area_1.GAME_SAFE_AREA.left + 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._backButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScoringState.prototype, "titleContainer", {
        get: function () {
            if (!this._titleContainer) {
                this._titleContainer = new title_container_1.default(this._app.loader.resources.ui.textures);
                this._titleContainer.setText(i18next_1.default.t("scoring_title"));
                this._titleContainer.position.set((game_area_1.GAME_WIDTH - this._titleContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._titleContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScoringState.prototype, "headerLabel", {
        get: function () {
            if (!this._headerLabel) {
                this._headerLabel = new PIXI.Text(i18next_1.default.t("scoring_header"));
                this._headerLabel.style = {
                    fontFamily: "Arial",
                    fontStyle: "italic",
                    fontSize: 18,
                    fill: color_1.COLOR.WHITE,
                    wordWrap: true,
                    wordWrapWidth: game_area_1.GAME_SAFE_AREA.width - 12 * 2
                };
            }
            return this._headerLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScoringState.prototype, "footerLabel", {
        get: function () {
            if (!this._footerLabel) {
                this._footerLabel = new PIXI.Text(i18next_1.default.t("scoring_footer"));
                this._footerLabel.style = {
                    fontFamily: "Arial",
                    fontStyle: "italic",
                    fontSize: 18,
                    fill: color_1.COLOR.WHITE,
                    wordWrap: true,
                    wordWrapWidth: game_area_1.GAME_SAFE_AREA.width - 12 * 2
                };
            }
            return this._footerLabel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScoringState.prototype, "scoringRows", {
        get: function () {
            var e_1, _a;
            if (!this._scoringRows) {
                this._scoringRows = [];
                try {
                    for (var _b = __values(Object.keys(scoring_1.SCORING_INFO)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var scoringID = _c.value;
                        var scoring = scoring_1.SCORING_INFO[scoringID];
                        if (scoringID.startsWith("park") && !this._client.park) {
                            continue;
                        }
                        var title = i18next_1.default.t("scoring_" + scoringID);
                        for (var replaceKey in scoring.replace) {
                            title = title.replace(replaceKey, scoring.replace[replaceKey]);
                        }
                        var button = new scoring_row_1.default(game_area_1.GAME_SAFE_AREA.width - 12 * 2);
                        button.setTitle(title, scoring.xp.toFixed() + " " + i18next_1.default.t("xp"));
                        this._scoringRows.push(button);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            return this._scoringRows;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScoringState.prototype, "tableContainer", {
        get: function () {
            if (!this._tableContainer) {
                this._tableContainer = new stack_container_1.default(this.scoringRows, {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.LEADING,
                    spacing: 10
                });
            }
            return this._tableContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ScoringState.prototype, "stackContainer", {
        get: function () {
            if (!this._stackContainer) {
                this._stackContainer = new stack_container_1.default([
                    this.headerLabel,
                    this.tableContainer,
                    this.footerLabel
                ], {
                    axis: stack_container_1.STACK_CONTAINER_AXIS.VERTICAL,
                    alignment: stack_container_1.STACK_CONTAINER_ALIGNMENT.CENTER,
                    spacing: 24,
                    minWidth: game_area_1.GAME_SAFE_AREA.width
                });
                this._stackContainer.position.set(game_area_1.GAME_SAFE_AREA.left, this.titleContainer.y + this.titleContainer.height + 16);
            }
            return this._stackContainer;
        },
        enumerable: false,
        configurable: true
    });
    ScoringState.prototype.didEnterFrom = function (previousState) {
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this.profileContainer);
        this._app.stage.addChild(this.backButton);
        this._app.stage.addChild(this.titleContainer);
        this._app.stage.addChild(this.stackContainer);
    };
    ScoringState.prototype.willExitTo = function (nextState) {
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this.profileContainer);
        this._app.stage.removeChild(this.backButton);
        this._app.stage.removeChild(this.titleContainer);
        this._app.stage.removeChild(this.stackContainer);
    };
    return ScoringState;
}(state_1.default));
exports.default = ScoringState;
